import Emitter from '../../services/emitter';
import UserAction from '../user';
import History from '../../util/history';
import { parseRoute } from '../../util';

/**
 * 登录成功事件
 *
 */
const onLogin = () => {
    Emitter.emit('RegisterDevice', 'login');
};

export default (store) => {
    window.addEventListener('message', (e) => {
        if (e.data === 'auth') {
            store.dispatch(UserAction.getUserState());
            History.replace(parseRoute('/'));
            onLogin();
        }
    });
    Emitter.on('AuthFinish', () => {
        store.dispatch(UserAction.getUserState(() => {
            setTimeout(() => {
                const { isLogin } = store.getState().account;
                if (isLogin) {
                    History.replace(parseRoute('/'));
                    onLogin();
                }
            }, 0);
        }));
    });
};

// 登录成功
Emitter.on('Login', onLogin);
// 重复登录
Emitter.on('RepeatAuth', onLogin);

